'use strict';

angular.module('selfAccessRequestControllers')

.controller('ArrivalSideBarSameAsController',
            ['$scope', '$state', '$stateParams', 'selfAccessRequest', 'selfAccessRequestService',
    function ($scope, $state, $stateParams, selfAccessRequest, selfAccessRequestService) {

        $scope.selfAccessRequest = selfAccessRequest;
        $scope.sameAsUserId = $stateParams.sameAsEmployeeID;

    }
]);